import { generatePath } from 'react-router';
import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { addParamsToUrl } from 'utils/query';
import { PdfReportLog, PaginationResponse } from 'types';

import { apiQuery } from '../../query';

import { PdfReportLogListRequest, PdfReportLogListResponse } from './types';

const tagType = 'PDF_REPORT_LOGS' as const;

export const pdfReportLogsApi = createApi({
  tagTypes: [tagType],
  baseQuery: apiQuery,
  reducerPath: 'pdfReportLogsApi',
  endpoints: (build) => ({
    list: build.query<
      PaginationResponse<PdfReportLog>,
      PdfReportLogListRequest
    >({
      providesTags: [tagType],
      transformResponse: (response: PdfReportLogListResponse) => response.data,
      query: ({ userId, ...params }) => ({
        method: 'get',
        url: addParamsToUrl(
          generatePath(URL.USER_PDF_REPORT_LOGS, { userId }),
          params
        ),
      }),
    }),
  }),
});

export const { useLazyListQuery } = pdfReportLogsApi;

export type { PdfReportLogListRequest };
